import React, { useState, useEffect } from "react";
import ReactRoundedImage from "react-rounded-image";
import { Col, Row, Container, Button } from "reactstrap";
import { baseurl } from "../../baseurl";
import { headers, companyId, username } from "../../utils/variables";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Responseloader from "./ShortCutComponents/ResponseLoader";
import "./recipePrintView.css";

const RecipePrintView = (props) => {
  console.log("props", props);
  console.log("props.branch", props?.location?.state?.branch);
  const branchId = props?.location?.state?.branch || null;
  const [loading, setLoading] = useState(true);
  const [recipeData, setRecipeData] = useState(null);
  const [error, setError] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const token = localStorage.getItem("token");

  const companylog = localStorage.getItem("profile_pic");
  const companySym = `${baseurl}/getImages/labelCard/?fileName=${companylog}`;
  const companyName = localStorage.getItem("companyName");
  const currentDateTime = moment().format("DD-MM-YYYY hh:mm A");
  const userEmail = localStorage.getItem("username") || "user@example.com";
  const currentPeriod = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  useEffect(() => {
    const recipeId = props.match?.params?.id || props.location?.state?.id;

    if (recipeId) {
      fetchRecipeData(recipeId);
    } else {
      setError("No recipe ID provided");
      setLoading(false);
    }
  }, [props]);

  const itemQtyAmt = async (id) => {
    try {
      // console.log(fSubInv);
      const response = await axios.post(
        `${baseurl}/lovs/getItemQtyAmt`,
        {
          companyId: companyId,
          username: username,
          id: id,
          sub_inv_id: branchId,
          date: moment(new Date()).format("YYYY-MM-DD"),
          qtyCheck: true,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      // Extract data from the response
      let amount = response.data.data1[0]?.funItemAmt || 0; // Default to 0 if undefined
      let qty = response.data.data2[0]?.funItemQty || 0; // Avoid division by 0
      let stockQty = response.data.data2[0]?.funItemQty || 0; // Avoid division by 0
      let rate = 0;
      if (amount > 0 && qty > 0) {
        rate = Number(amount) / Number(qty);
      }

      // Return the values
      return { qty, rate, amount, stockQty };
    } catch (error) {
      console.error("Error fetching item quantity and amount:", error);
      return { qty: 0, rate: 0 }; // Return default values in case of an error
    }
  };

  const fetchRecipeData = async (recipeId) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${baseurl}/pointOfSale/getRecipeWithId`,
        {
          id: recipeId,
          companyId,
          username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      const recipeDetails = response.data.data;
      if (recipeDetails && recipeDetails.length > 0) {
        // Process the data similar to your main Recipe component
        const formValues = await Promise.all(
          recipeDetails.map(async (item) => {
            const quantity = parseFloat(item.qty) || 0;
            const totalCost = parseFloat(item.total) || 0;
            let avgRate = 0;
            if (quantity > 0 && totalCost > 0) {
              avgRate = totalCost / quantity;
            }

            // ? FIX: Use await to get the actual values
            const { qty, rate, amount, stockQty } = await itemQtyAmt(
              item.dt_item_id
            );

            console.log("item.dt_item_code", item.dt_item_code);
            console.log("qty", qty);
            console.log("rate", rate);

            console.log("amount", amount);
            console.log("stockQty", stockQty);
            console.log("parseFloat(item.qty)", parseFloat(item.qty));
            const costPerUnit = (parseFloat(rate) /  parseFloat(item.item_unit_ratio)).toFixed(2)|| 1;
            const total       = parseFloat(costPerUnit)* parseFloat(item.qty);
            const wasteAmt    = parseFloat(costPerUnit) * parseFloat(item.waste_qty);
            const netQty      = quantity + parseFloat(item.waste_qty);
            const netCost     = total + wasteAmt;
            console.log('total', total)

            return {
              detId: item.detId,
              itemCode: {
                id: item.dt_item_id,
                label: item.dt_item_code,
              },
              uomName: item.dt_item_desc_uom,
              quantity,
              costPerUnit: costPerUnit,
              avgRate: rate || avgRate || 0, //: funAvgRate, // ? Added
              total: total,
              wastePer: item.dt_waste_perc,
              wasteQty: item.waste_qty,
              wasteAmt: wasteAmt,
              netQty:netQty,
              netCost: netCost,
              currDate: item.dt_last_update,
            };
          })
        );

        // Calculate totals
        const totalValues = {
          totAmt: formValues.reduce(
            (sum, item) => sum + (parseFloat(item.total) || 0),
            0
          ),
          totWasteAmt: formValues.reduce(
            (sum, item) => sum + (parseFloat(item.wasteAmt) || 0),
            0
          ),
          totNetQty: formValues.reduce(
            (sum, item) => sum + (parseFloat(item.netQty) || 0),
            0
          ),
          totNetCost: formValues.reduce(
            (sum, item) => sum + (parseFloat(item.netCost) || 0),
            0
          ),
        };

        const costing = {
          costMaterial: totalValues.totAmt,
          costWaste: totalValues.totWasteAmt,
          costFood: totalValues.totAmt + totalValues.totWasteAmt,
        };

        const mainRecipe = recipeDetails[0];
        const data = {
          formValues,
          itemType: mainRecipe.master_itemType_id,
          CodeMaster: {
            id: mainRecipe.master_item_id,
            label: mainRecipe.master_item_code,
          },
          purchaseUom: mainRecipe.master_item_uom_desc,
          producedQty: mainRecipe.master_produce_qty,
          salesOutlet: mainRecipe.mfg_on_pos_yn,
          method: mainRecipe.master_method_det,
          notes: mainRecipe.master_special_notes,
        };

        const salesPrice = {
          SpActual: mainRecipe.master_MenuRate,
          SpSuggested: mainRecipe.master_MenuRate, // You might want to calculate this
        };

        const grossProfit = {
          gpPer: mainRecipe.master_gp_perc,
          gpFoodCost: mainRecipe.master_food_cost_perc,
          gpOverHead:
            100 -
            (mainRecipe.master_gp_perc + mainRecipe.master_food_cost_perc),
          gpSuggested: mainRecipe.master_gp_suggested,
          gpActual: mainRecipe.master_gp_actual,
        };

        setRecipeData({
          data,
          totalValues,
          costing,
          salesPrice,
          grossProfit,
        });
      } else {
        setError("Recipe not found");
      }
    } catch (err) {
      console.error("Error fetching recipe data:", err);
      setError("Failed to load recipe data");
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (value) => {
    if (!value && value !== 0) return "-";
    const num =
      typeof value === "string"
        ? parseFloat(value.replace(/,/g, "")) || 0
        : value || 0;
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const generatePDF = () => {
    if (!recipeData) return;

    setPdfLoading(true);
    try {
      const { data, totalValues, costing, salesPrice, grossProfit } =
        recipeData;
      const doc = new jsPDF();
      let yPosition = 20;
      const margin = 20;
      const pageWidth = doc.internal.pageSize.width;
      const contentWidth = pageWidth - margin * 2;

      // --- HEADER ---
      doc.setFontSize(18).setFont("helvetica", "bold");
      doc.text(companyName.toUpperCase(), pageWidth / 2, yPosition, {
        align: "center",
      });
      const printedDate = moment().format("DD-MM-YYYY"); // or your format
      doc.setFontSize(9).setFont("helvetica", "normal");
      doc.text(`Printed on: ${printedDate}`, pageWidth - margin, yPosition, {
        align: "right",
      });

      yPosition += 10;
      doc.setFontSize(14).setFont("helvetica", "bold");
      doc.text("RECIPE DETAILS", pageWidth / 2, yPosition, { align: "center" });

      yPosition += 15;

      // --- RECIPE INFO TABLE - 2 COLUMN LAYOUT ---
      doc.autoTable({
        startY: yPosition,
        margin: { left: margin },
        theme: "plain",
        styles: { fontSize: 10 },
        tableWidth: contentWidth,
        body: [
          [
            { content: "Item Type:", styles: { fontStyle: "bold" } },
            data.itemType === 1
              ? "Menu Item"
              : data.itemType === 3
              ? "Sub-Recipe"
              : "N/A",
            { content: "Produced Quantity:", styles: { fontStyle: "bold" } },
            `${formatNumber(data.producedQty)} ${data.purchaseUom || ""}`,
          ],
          [
            { content: "Item Code:", styles: { fontStyle: "bold" } },
            data.CodeMaster?.label || "N/A",
            {
              content: "Manufacturing at Sales Outlet:",
              styles: { fontStyle: "bold" },
            },
            data.salesOutlet === 1 ? "Yes" : "No",
          ],
          [
            { content: "As on Date:", styles: { fontStyle: "bold" } },
            moment().format("DD-MM-YYYY"),
            "", // keep blank for alignment in 4-column layout
            "",
          ],
        ],
      });

      yPosition = doc.lastAutoTable.finalY + 10;

      // --- INGREDIENTS TABLE ---
      const tableColumns = [
        { header: "#", dataKey: "index" },
        { header: "Item Code", dataKey: "itemCode" },
        { header: "Unit", dataKey: "unit" },
        { header: "Quantity", dataKey: "quantity" },
        { header: "Cost/Unit", dataKey: "costPerUnit" },
        { header: "Avg Rate", dataKey: "avgRate" },

        { header: "Total", dataKey: "total" },
        { header: "Waste %", dataKey: "wastePer" },
        { header: "Waste Qty", dataKey: "wasteQty" },
        { header: "Waste Amt", dataKey: "wasteAmt" },
        { header: "Net Cost", dataKey: "netCost" },
        { header: "Net Qty", dataKey: "netQty" },
      ];

      const tableData = data.formValues.map((item, index) => ({
        index: index + 1,
        itemCode: item.itemCode?.label || "",
        unit: item.uomName || "",
        quantity: formatNumber(item.quantity),
        costPerUnit: formatNumber(item.costPerUnit),
        avgRate: formatNumber(item.avgRate),
        total: formatNumber(item.total),
        wastePer: formatNumber(item.wastePer),
        wasteQty: formatNumber(item.wasteQty),
        wasteAmt: formatNumber(item.wasteAmt),
        netCost: formatNumber(item.netCost),
        netQty: formatNumber(item.netQty),
      }));

      tableData.push({
        index: "TOTALS",
        itemCode: "",
        unit: "",
        quantity: "",
        costPerUnit: "",
        avgRate: "",
        total: formatNumber(totalValues.totAmt),
        wastePer: "-",
        wasteQty: "-",
        wasteAmt: formatNumber(totalValues.totWasteAmt),
        netCost: formatNumber(totalValues.totNetCost),
        netQty: formatNumber(totalValues.totNetQty),
      });

      doc.autoTable({
        startY: yPosition,
        head: [tableColumns.map((col) => col.header)],
        body: tableData.map((row) =>
          tableColumns.map((col) => row[col.dataKey])
        ),
        margin: { left: margin },
        theme: "grid", // ? enables borders on head + body
        styles: {
          fontSize: 8,
          // lineWidth: 0.3, // ? thin black border
          // lineColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [230, 230, 230], // ? slightly darker gray
          fontStyle: "bold",
          textColor: [0, 0, 0],
          lineWidth: 0.3,
          // lineColor: [0, 0, 0],
        },
        alternateRowStyles: { fillColor: [250, 250, 250] },
        columnStyles: {
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
          7: { halign: "right" },
          8: { halign: "right" },
          9: { halign: "right" },
          10: { halign: "right" },
        },
      });

      yPosition = doc.lastAutoTable.finalY + 15;

      // --- 3 COLUMN LAYOUT (Side-by-side boxes) ---
      // --- SUMMARY TABLE (Costing | Gross Profit | Sales Price) ---
      // --- SUMMARY TABLE (Costing | Gross Profit | Sales Price) ---
      yPosition = doc.lastAutoTable.finalY + 15;

      const tableWidth = contentWidth / 3 - 2; // divide into 3 equal parts with small gap
      const tableGap = 3;

      // Table 1: COSTING
      doc.autoTable({
        startY: yPosition,
        margin: { left: margin },
        theme: "grid",
        tableWidth: tableWidth,
        head: [
          [
            {
              content: "COSTING",
              colSpan: 2,
              styles: { halign: "center", fontStyle: "bold" },
            },
          ],
        ],
        body: [
          ["Material", formatNumber(costing.costMaterial)],
          ["Waste", formatNumber(costing.costWaste)],
          ["Food Cost", formatNumber(costing.costFood)],
        ],
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: 0,
          lineWidth: 0.3,
        },
        columnStyles: {
          0: { fontStyle: "bold" },
          1: { halign: "right" },
        },
      });

      const table1FinalY = doc.lastAutoTable.finalY;

      // Table 2: GROSS PROFIT
      doc.autoTable({
        startY: yPosition,
        margin: { left: margin + tableWidth + tableGap },
        theme: "grid",
        tableWidth: tableWidth,
        head: [
          [
            {
              content: "GROSS PROFIT",
              colSpan: 2,
              styles: { halign: "center", fontStyle: "bold" },
            },
          ],
        ],
        body: [
          ["Gross Profit %", formatNumber(grossProfit.gpPer) + "%"],
          ["Food Cost %", formatNumber(grossProfit.gpFoodCost) + "%"],
          ["Overhead %", formatNumber(grossProfit.gpOverHead) + "%"],
          [
            "Suggested GP",
            grossProfit.gpSuggested
              ? formatNumber(grossProfit.gpSuggested)
              : "-",
          ],
          [
            "Actual GP",
            grossProfit.gpActual ? formatNumber(grossProfit.gpActual) : "-",
          ],
        ],
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: 0,
          lineWidth: 0.3,
        },
        columnStyles: {
          0: { fontStyle: "bold" },
          1: { halign: "right" },
        },
      });

      const table2FinalY = doc.lastAutoTable.finalY;

      // Table 3: SALES PRICE
      doc.autoTable({
        startY: yPosition,
        margin: { left: margin + (tableWidth + tableGap) * 2 },
        theme: "grid",
        tableWidth: tableWidth,
        head: [
          [
            {
              content: "SALES PRICE",
              colSpan: 2,
              styles: { halign: "center", fontStyle: "bold" },
            },
          ],
        ],
        body: [
          ["Suggested", formatNumber(salesPrice.SpSuggested)],
          ["Actual", formatNumber(salesPrice.SpActual)],
        ],
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: 0,
          lineWidth: 0.3,
        },
        columnStyles: {
          0: { fontStyle: "bold" },
          1: { halign: "right" },
        },
      });

      const table3FinalY = doc.lastAutoTable.finalY;

      // Move cursor below all three tables
      yPosition = Math.max(table1FinalY, table2FinalY, table3FinalY) + 12;
      // spacing after section

      // --- SAVE FILE ---
      doc.save(
        `Recipe_${data.CodeMaster?.label?.replace(
          /[^a-zA-Z0-9]/g,
          "_"
        )}_${moment().format("YYYY-MM-DD")}.pdf`
      );
    } catch (err) {
      console.error(err);
      alert("Error generating PDF");
    } finally {
      setPdfLoading(false);
    }
  };

  if (loading) {
    return <Responseloader />;
  }

  if (error && !recipeData) {
    return <Redirect to="/RecipeOV" />;
  }

  const { data, totalValues, costing, salesPrice, grossProfit } = recipeData;

  return (
    <div className="pdfContent-Print bg-white">
      <Row className="app-body-Invoice">
        <Col xs="12">
          {/* Header with Print and Download buttons */}
          <Row className="mb-4">
            <Col xs="4" className="d-flex align-items-center">
              <ReactRoundedImage
                className="ReactRoundedImage"
                image={companySym}
                roundedColor="#321124"
                imageWidth="50"
                imageHeight="45"
                roundedSize="4"
              />
              <h3 className="ml-3">{companyName}</h3>
            </Col>
            <Col xs="4" className="text-center">
              <h2 className="">
                <u>RECIPE DETAILS</u>
              </h2>
            </Col>
            <Col xs="4" className="text-right mt-1">
              <Button
                className="btn btn-success"
                onClick={generatePDF}
                disabled={pdfLoading}
              >
                {pdfLoading ? (
                  <>
                    <i className="fa fa-spinner fa-spin"></i> Generating...
                  </>
                ) : (
                  <>
                    <i className="fa fa-download"></i> Download PDF
                  </>
                )}
              </Button>
              <Link to="/RecipeOV" className="btn btn-secondary mx-2 mt-1">
                <i className="fa fa-arrow-left"></i> Back
              </Link>
            </Col>
          </Row>

          <hr style={{ border: "1px solid #dee2e6" }} />

          {/* Recipe Information */}
          <Row className="mb-4 px-4">
            <Col xs="12">
              <Row className="align-items-start">
                <Col xs="6">
                  <div className="d-flex mb-2">
                    <strong className="me-3" style={{ minWidth: "80px" }}>
                      Item Type:
                    </strong>{" "}
                    <span>
                      {data.itemType === 1
                        ? "Menu Item"
                        : data.itemType === 3
                        ? "Sub-Recipe"
                        : "N/A"}
                    </span>
                  </div>
                  <div className="d-flex mb-2">
                    <strong className="me-3" style={{ minWidth: "80px" }}>
                      Item Code:
                    </strong>{" "}
                    <span>{data.CodeMaster?.label || "N/A"}</span>
                  </div>
                </Col>

                <Col xs="6">
                  <div className="d-flex mb-2">
                    <strong
                      className="me-3 text-end"
                      style={{ minWidth: "210px" }}
                    >
                      Produced Quantity:
                    </strong>
                    <span>
                      {formatNumber(data.producedQty)} {data.purchaseUom || ""}
                    </span>
                  </div>
                  <div className="d-flex mb-2">
                    <strong
                      className="me-3 text-end"
                      style={{ minWidth: "210px" }}
                    >
                      Manufacturing at Sales Outlet:
                    </strong>
                    <span>{data.salesOutlet === 1 ? "Yes" : "No"}</span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          {/* Ingredients Table */}
          <Row className="mb-4 px-4">
            <Col xs="12">
              <div className="table-responsive">
                <table
                  className="table table-bordered"
                  style={{ fontSize: "14px", width: "100%" }}
                >
                  <thead className="thead-light">
                    <tr>
                      <th className="text-dark">#</th>
                      <th className="text-dark">Item Code</th>
                      <th className="text-dark">Unit</th>
                      <th className="text-center text-dark">Quantity</th>
                      <th className="text-center text-dark">Cost/Unit</th>
                      <th className="text-center">Avg Rate</th>
                      <th className="text-center text-dark">Total</th>
                      <th className="text-center text-dark">Waste %</th>
                      <th className="text-center text-dark">Waste Qty</th>
                      <th className="text-center text-dark">Waste Amt</th>
                      <th className="text-center text-dark">Net Cost</th>
                      <th className="text-center text-dark">Net Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.formValues.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.itemCode?.label || "N/A"}</td>
                        <td>{item.uomName || ""}</td>
                        <td className="text-right">
                          {formatNumber(item.quantity)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.costPerUnit)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.avgRate)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.total)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.wastePer)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.wasteQty)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.wasteAmt)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.netCost)}
                        </td>
                        <td className="text-right">
                          {formatNumber(item.netQty)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="font-weight-bold">
                    <tr>
                      <td colSpan="6">TOTALS</td>
                      <td className="text-right">
                        {formatNumber(totalValues.totAmt)}
                      </td>
                      <td className="text-right">-</td>
                      <td className="text-right">-</td>
                      <td className="text-right">
                        {formatNumber(totalValues.totWasteAmt)}
                      </td>
                      <td className="text-right">
                        {formatNumber(totalValues.totNetCost)}
                      </td>
                      <td className="text-right">
                        {formatNumber(totalValues.totNetQty)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </Col>
          </Row>

          {/* Costing Summary */}

          <Row className="mb-5 px-4">
            <Col xs="12">
              <div className="d-flex justify-content-between">
                {/* COSTING */}

                <div
                  className="p-2  border border-secondary shadow-sm rounded"
                  style={{ width: "300px" }}
                >
                  <h5 className="mb-2 text-dark fw-bold text-center">
                    Costing
                  </h5>
                  <table className="table table-bordered table-sm mb-2 text-center">
                    <thead>
                      <tr>
                        <th>Material</th>
                        <th>Waste</th>
                        <th>Food Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-right">
                          {formatNumber(costing.costMaterial)}
                        </td>
                        <td className="text-right">
                          {formatNumber(costing.costWaste)}
                        </td>
                        <td className="text-right">
                          {formatNumber(costing.costFood)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* GROSS PROFIT (only menu item) */}
                {data.itemType === 1 && (
                  <div
                    className="p-2 border border-secondary shadow-sm rounded"
                    style={{ width: "500px" }}
                  >
                    <h5 className="mb-2 text-dark fw-bold text-center">
                      Gross Profit
                    </h5>
                    <table className="table table-bordered table-sm text-center mb-2">
                      <thead>
                        <tr>
                          <th>Gross Profit %</th>
                          <th>Food Cost %</th>
                          <th>Overhead %</th>
                          <th>Suggested GP</th>
                          <th>Actual GP</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-right">
                            {formatNumber(grossProfit.gpPer)}%
                          </td>
                          <td className="text-right">
                            {formatNumber(grossProfit.gpFoodCost)}%
                          </td>
                          <td className="text-right">
                            {formatNumber(grossProfit.gpOverHead)}%
                          </td>
                          <td className="text-right">
                            {formatNumber(grossProfit.gpSuggested)}
                          </td>
                          <td className="text-right">
                            {formatNumber(grossProfit.gpActual)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
                {/* SALES PRICE */}
                {data.itemType === 1 && (
                  <div
                    className="p-2 border border-secondary shadow-sm rounded"
                    style={{ width: "200px" }}
                  >
                    <h5 className="mb-2 text-dark fw-bold text-center">
                      Sales Price
                    </h5>
                    <table className="table table-bordered table-sm text-center mb-2 text-center">
                      <thead>
                        <tr>
                          <th>Suggested</th>
                          <th>Actual</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-right">
                            {formatNumber(salesPrice.SpSuggested)}
                          </td>
                          <td className="text-right">
                            {formatNumber(salesPrice.SpActual)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {/* Footer */}
          {/* <Row className="mt-5 pt-3 border-top px-4">
            <Col xs="12" className="text-center text-muted small">
              <div>
                Document generated on {currentDateTime} - Printed by:{" "}
                {userEmail}
              </div>
            </Col>
          </Row> */}
        </Col>
      </Row>
    </div>
  );
};

export default RecipePrintView;
